'use strict';

var Marionette = require('backbone.marionette');
var twig = require('twig').twig;
var itemTpl = require('manage/details/ports/aggregated/aggregated-port.html');

/**
 * Displays a aggregated ports status.
 */
module.exports = Marionette.View.extend({
  template: twig({data: itemTpl}),

  modelEvents: {
    'change': 'render',
  },
});
